import React from 'react';

export const HiveBackground: React.FC = () => {
  return (
    <div
      className="fixed inset-0 opacity-30 mix-blend-normal pointer-events-none z-0"
      style={{
        backgroundImage: 'url(/beehive-background.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    />
  );
};
